import React from 'react';
import { Link } from 'react-router-dom';
import AddBoxIcon from '@material-ui/icons/AddBox';
import { withStyles } from '@material-ui/core/styles';
import { Button } from 'react-admin';

const styles = {
  button: {
    marginTop: '1em'
  }
};

const AddAttributeButton = ({ classes, record }) => (
  <Button
    className={classes.button}
    variant="contained"
    component={Link}
    to={`/ai_tool_parameters/create?tool=${record['@id']}`}
    label="Add a parameter"
    title="Add a parameter"
  >
    <AddBoxIcon />
  </Button>
);

export default withStyles(styles)(AddAttributeButton);
